export default __webpack_public_path__ + "static/media/icon-Hub-Projects.5d0de818.svg";